module.exports = __webpack_public_path__ + "static/om-eeba5214a195c15f9afb7f48460d1c07.svg";